// Recover from stale dynamic-import chunks after a deploy.
//
// When Vite's preload helper fails to fetch a hashed sibling chunk (because the
// browser cached an older parent chunk that references a hash no longer on the
// asset host), Vite emits `vite:preloadError` instead of throwing. Without a
// listener, the failure surfaces as an uncaught `SyntaxError` and the page is
// stuck. Reloading once pulls fresh HTML + manifest pointing at chunks that
// exist. The sessionStorage guard prevents reload loops if the asset host is
// genuinely unreachable.
const RELOAD_GUARD_KEY = "vitePreloadReloaded"

window.addEventListener("vite:preloadError", (event) => {
  if (sessionStorage.getItem(RELOAD_GUARD_KEY) === "1") return
  sessionStorage.setItem(RELOAD_GUARD_KEY, "1")
  event.preventDefault()
  window.location.reload()
})

window.addEventListener("load", () => {
  sessionStorage.removeItem(RELOAD_GUARD_KEY)
})
